import styled from '@emotion/styled'

export const DisabledOuterWrapper = styled.div`
  cursor: not-allowed;
`

export const DisabledInnerWrapper = styled.span`
  pointer-events: none;
`
